import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const BeforeRedeemableSection = () =>
  <React.Fragment>
    <div className="referral-title">
      <h3>
        <FormattedMessage id="beforedeemablesection.title.how-it-works" defaultMessage="How to get your gift" />
      </h3>
    </div>
    <div className="brand-line my-3 mx-auto" />

    <div className="how-it-works-icons-container">
      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/signup.svg"
              alt="Create Account"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="beforedeemablesection.signup" defaultMessage="Create an Account" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="beforedeemablesection.signup.subtitle"
            defaultMessage="Click the button above to create an account to keep your keys secure, or if you already have an account, simply sign in!"
          />
        </p>
      </div>

      <div className="chevron-container">
        <FontAwesomeIcon icon={faChevronRight} size="2x" className="referral-chevron" />
      </div>

      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/gift.svg"
              alt="accept gift"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="beforedeemablesection.acceptyourgift" defaultMessage="Accept your gift" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="beforedeemablesection.acceptyourgift.subtitle"
            defaultMessage="You’ll be taken to a page where you can see your gifts. Click the “ACCEPT” button to continue"
          />
        </p>
      </div>

      <div className="chevron-container">
        <FontAwesomeIcon icon={faChevronRight} size="2x" className="referral-chevron" />
      </div>

      <div className="referral-icon-container">
        <div className="referral-circle">
          <div className="step-icon cart-add">
            <img
              loading="lazy"
              src="https://cdn.fanatical.com/production/icons/slim-icons/dark-icons/box-download.svg"
              alt="Redeem your keys"
            />
          </div>
        </div>
        <p className="referral-circle-title">
          <FormattedMessage id="beforedeemablesection.redeemyourkeys" defaultMessage="Redeem your keys" />
        </p>
        <p className="referral-circle-subtitle">
          <FormattedMessage
            id="beforedeemablesection.redeemyourkeys.subtitle"
            defaultMessage="Within your Account you’ll be able to reveal your keys, which can be redeemed instantly."
          />
        </p>
      </div>
    </div>

  </React.Fragment>;

export default BeforeRedeemableSection;
